export default "__VITE_PUBLIC_ASSET__c8a0be4f__"